export const isVideoPlayable = (
  isAccountTrial: boolean,
  isTrial: boolean,
  videoUrl?: string
) => {
  return (!isAccountTrial || isTrial) && !!videoUrl;
};